import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';
import '../../../tslib.es6-a39f91fc.js';
import '../../../index-6ea95111.js';
import '../../../style-inject.es-1f59c1d0.js';

var StarFilledIcon = (function (props) {
    return createElement(IconWrapper, props, jsx("path", { fill: "currentColor", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 2, d: "M11.888 2h.129c.502.003.952.313 1.13.78l2.006 5.068 5.679.266c1.128.048 1.59 1.464.703 2.16l-4.433 3.546 1.84 5.653c.286 1.071-.906 1.93-1.84 1.325L12 17l-5 3.798c-.935.608-2.132-.252-1.844-1.325L6.9 13.82l-4.434-3.546c-.886-.696-.425-2.112.703-2.16l5.68-.266 2.021-5.068A1.224 1.224 0 0 1 11.889 2Z" }));
});

export default StarFilledIcon;
//# sourceMappingURL=StarFilled.js.map
